export default __webpack_public_path__ + "static/media/small.57b822e0.jpg";